import React, { useContext, useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import { MultiStepContext } from '../StepContext2';

export default function Questions2() {
    const { setStep, vendorData, setVendorData, vendorsubmitData } = useContext(MultiStepContext);
    const [error, setError] = useState(null);

    const handleSubmit = () => {
        if (!vendorData.ans1 || !vendorData.ans2 || !vendorData.ans3) {
            setError("Please fill in all fields.");
        } else {
            setError(null);
            vendorsubmitData();
        }
    };

    return (
        <div>
            <h4 style={{textAlign:'center'}}>Security Questions</h4>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Primary School Name"
                margin='normal'
                value={vendorData['ans1'] || ''}
                onChange={(e) => setVendorData({ ...vendorData, "ans1": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Favourite Food"
                margin='normal'
                value={vendorData['ans2'] || ''}
                onChange={(e) => setVendorData({ ...vendorData, "ans2": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Best Friend Name"
                margin='normal'
                value={vendorData['ans3'] || ''}
                onChange={(e) => setVendorData({ ...vendorData, "ans3": e.target.value })}
                variant='outlined'
            />
            </div>
            {error && <p style={{color: 'red'}}>{error}</p>}
            <div className="signupbtnn">  
                <Button variant='contained' onClick={() => setStep(1)} color='secondary'>Back</Button>
                <Button variant='contained' style={{float:'right'}} onClick={handleSubmit} color='primary'>Submit</Button> 
            </div>    
        </div>
    );
}
